import {
  IChangePasswordPayload,
  IUpdateSettingsPayload,
} from '@/types/payload';

import http from './http';
import serviceHelper from './serviceHelper';

export const getSettings = async () => {
  return serviceHelper(http.get('/admin/settings'), false);
};

export const updateSettings = async (data: IUpdateSettingsPayload) => {
  return serviceHelper(http.patch('/admin/settings', data), true);
};

export const changePassword = async (data: IChangePasswordPayload) => {
  return serviceHelper(http.post('/admin/change-password', data), true);
};

export const getMaintenanceMode = async () => {
  return serviceHelper(http.get('/admin/settings/maintenance-mode'), false);
};

export const updateMaintenanceMode = async (data: { is_enabled: boolean }) => {
  return serviceHelper(
    http.patch('/admin/settings/maintenance-mode', data),
    true
  );
};
